import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { FormAuthenticationmessage } from "./FormAuthenticationmessage";
import "./contact.css";
import axios from "axios";
import { animateScroll as scroll } from "react-scroll";
import Swal from "sweetalert2";

const inputClass =
  "py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3";

export const ContactSection3 = () => {
  const handleLinkClick = () => {
    scroll.scrollToTop();
  };

  const validate = Yup.object({
    companyName: Yup.string().required("Company name is Required"),
    address: Yup.string().required("Address is Required"),
    zip: Yup.string().required("Zip code is Required"),
    city: Yup.string().required("City is Required"),
    state: Yup.string().required("State/Province is Required"),
    country: Yup.string().required("Country is Required"),
    title: Yup.string().required("Title is Required"),
    firstName: Yup.string().required("First Name is Required"),
    lastName: Yup.string().required("Last Name is Required"),
    jobTitle: Yup.string().required("Job Title is Required"),
    telephoneNumber: Yup.string().required("Telephone Number is Required"),
    emailAddress: Yup.string().email("Invalid email address"),
    acceptPolices: Yup.boolean().oneOf([true], "Accept Policies is required"),
  });

  return (
    <Formik
      initialValues={{
        companyName: "",
        address: "",
        zip: "",
        city: "",
        state: "",
        country: "",
        title: "",
        firstName: "",
        lastName: "",
        jobTitle: "",
        telephoneNumber: "",
        emailAddress: "",
        checkboxes: [],
        certificationbody: "",
        question1: "",
        question2: "",
        question3: "",
        question4: "",
        question5: "",
        selectedCountry: "",
        acceptPolices: false,
      }}
      validationSchema={validate}
      validateOnBlur={true}
      validateOnChange={true}
      onSubmit={async (values, { resetForm }) => {
        try {
          Swal.fire({
            title: "Sending Data",
            text: "Please wait...",
            icon: "info",
            allowOutsideClick: false,
            showConfirmButton: false,
            showCancelButton: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          await validate.validate(values, { abortEarly: false });

          resetForm();
          await axios.post("https://api.mbasolutions.co/certifications", values);

          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Data has been sent successfully",
          });
        } catch (error) {
          console.error(error);

          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Network Error.Please Try Again Later.",
          });
        }
      }}
    >
      {(formik) => (
        <div className="w-[92%] md:w-[88%] lg:w-[84%] mx-auto overflow-x-hidden mb-16 md:mb-20">
          <div className="bg-white rounded-3xl shadow-xl border border-[#f2d7b8] px-4 md:px-10 lg:px-12 py-10 md:py-12">
            <h1 className="w-fit px-5 md:px-10 mx-auto py-4 text-center bg-[#fff8f0] rounded-xl text-[#1B1C19] shadow-md font-bold text-lg md:text-2xl">
              Your Process for Certification Starts Here!
            </h1>
            <p className="text-center text-[#4c4d56] mt-4 mb-8 max-w-3xl mx-auto">
              Fill out the details below and our team will guide you through the
              next steps.
            </p>

            <Form className="text-[#4c4d56]">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="text-[#4c4d56]" htmlFor="companyName">
                    Name of Your Company*
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="companyName"
                    name="companyName"
                    className={inputClass}
                    placeholder="Name"
                  />
                </div>
                <div>
                  <label className="text-[#4c4d56]" htmlFor="address">
                    Address*
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="address"
                    name="address"
                    className={inputClass}
                    placeholder="Address"
                  />
                </div>
                <div>
                  <label className="text-[#4c4d56]" htmlFor="zip">
                    ZIP*
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="zip"
                    name="zip"
                    className={inputClass}
                    placeholder="ZIP"
                  />
                </div>
                <div>
                  <label className="text-[#4c4d56]" htmlFor="city">
                    City*
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="city"
                    name="city"
                    className={inputClass}
                    placeholder="City"
                  />
                </div>
                <div>
                  <label className="text-[#4c4d56]" htmlFor="state">
                    State/Province*
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="state"
                    name="state"
                    className={inputClass}
                    placeholder="State/Province"
                  />
                </div>
                <div>
                  <label className="text-[#4c4d56]" htmlFor="country">
                    Country*
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="country"
                    name="country"
                    className={inputClass}
                    placeholder="Country"
                  />
                </div>
              </div>

              <div className="mt-8 p-4 md:p-6 bg-[#fffaf4] rounded-2xl border border-[#f7e4cc]">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label className="text-[#4c4d56]" htmlFor="title">
                      Title*
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="title"
                      name="title"
                      placeholder="Title"
                      className={inputClass}
                    />
                  </div>
                  <div>
                    <label className="text-[#4c4d56]" htmlFor="firstName">
                      First Name*
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="firstName"
                      placeholder="First Name"
                      name="firstName"
                      className={inputClass}
                    />
                  </div>
                  <div>
                    <label className="text-[#4c4d56]" htmlFor="lastName">
                      Last Name*
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="lastName"
                      name="lastName"
                      placeholder="Last Name"
                      className={inputClass}
                    />
                  </div>
                  <div>
                    <label className="text-[#4c4d56]" htmlFor="jobTitle">
                      Job Title*
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="jobTitle"
                      name="jobTitle"
                      placeholder="Job Title"
                      className={inputClass}
                    />
                  </div>
                  <div>
                    <label className="text-[#4c4d56]" htmlFor="telephoneNumber">
                      Telephone Number*
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="telephoneNumber"
                      placeholder="Telephone Number"
                      name="telephoneNumber"
                      className={inputClass}
                    />
                  </div>
                  <div>
                    <label className="text-[#4c4d56]" htmlFor="emailAddress">
                      Email
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="emailAddress"
                      placeholder="Email"
                      name="emailAddress"
                      className={inputClass}
                    />
                  </div>
                </div>
              </div>

              <div className="my-10 flex items-center space-x-4">
                <FormAuthenticationmessage
                  type="checkbox"
                  name="acceptPolices"
                  className="w-5 h-5 accent-orange-500"
                  label="I Accept The Validity And Authenticity Of Above Information In Application Form"
                  checked={formik.values.acceptPolices}
                />
              </div>

              <div className="flex flex-wrap gap-3 md:gap-6">
                <button
                  type="submit"
                  className="btn bg-orange-500 hover:shadow-lg hover:bg-orange-600 transition-all duration-200 ease-out text-white cursor-pointer px-6 md:px-8 py-3 rounded-md text-lg font-semibold"
                >
                  Submit
                </button>
                <button
                  className="btn hover:shadow-lg bg-gray-500 hover:bg-gray-600 transition-all duration-200 ease-out text-white cursor-pointer px-6 md:px-8 py-3 rounded-md text-lg font-semibold"
                  type="reset"
                  onClick={handleLinkClick}
                >
                  Reset
                </button>
              </div>
            </Form>
          </div>
        </div>
      )}
    </Formik>
  );
};
